import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";

const RDark = `${process.env.PUBLIC_URL || ""}/logo/R dark.svg`;
const RLight = `${process.env.PUBLIC_URL || ""}/logo/R light.svg`;
const SDark = `${process.env.PUBLIC_URL || ""}/logo/S dark.svg`;
const SLight = `${process.env.PUBLIC_URL || ""}/logo/S light.svg`;

export default function RandoStatLogo({
  // size = 36,
  showText = true,
  gap = 0.08,
  sx = {},
}) {
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.only("xs"), { noSsr: true });
  const isDark = theme.palette.mode === "dark";

  const rSrc = isDark || isXsScreen ? RDark : RLight;
  const sSrc = isDark ? SDark : SLight;

  const textColor = theme.palette.text.primary;
  let size = isDark ? 30 : 36;
  const ballSize = isXsScreen ? 30 : size * 1.06;
  const sLogoHeight = 0.97 * ballSize;
  const sLogoAspectRatio = isDark ? (161.82401 / 347.98801) : (136 / 347.98801);
  const sLogoWidth = sLogoHeight * sLogoAspectRatio;
  // const fontSize = isDark ? size * 0.88 : size * 0.73;
  const fontSize = isDark ? "1.7em" : "1.65em";
  const fontWeight = 500;
  const letterSpacing = "-0.02em";

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        lineHeight: 1,
        userSelect: "none",
        whiteSpace: "nowrap",
        ...sx,
        // fontFamily: "Segoe UI",
        pl: 1
      }}
    >
      <Box
        component="img"
        src={rSrc}
        alt="R"
        sx={{
          width: `${ballSize}px`,
          height: `${ballSize}px`,
          display: "block",
          flexShrink: 0,
          mr: `${gap}em`,
          mb: `${gap}em`
          // transform: "translateY(-0.06em)"
        }}
      />

      {showText && (
        <>
          <Box
            component="span"
            sx={{
              // fontSize: `${fontSize}px`,
              fontSize: { fontSize },
              fontWeight: fontWeight,
              // lineHeight: 1,
              letterSpacing,
              color: textColor,
              marginLeft: isDark ? `-.35em` : `-.51em`,
            }}
          >
            ando
          </Box>

          <Box
            component="img"
            src={sSrc}
            alt="S"
            sx={{
              height: `${sLogoHeight}px`,
              width: `${sLogoWidth}px`,
              display: "block",
              flexShrink: 0,
              // mx: "0.00em",
              ml: "-0.06em",
            }}
          />

          <Box
            component="span"
            sx={{
              // fontSize: `${fontSize}px`,
              fontSize: { fontSize },
              fontWeight: fontWeight,
              // lineHeight: 1,
              letterSpacing,
              color: textColor,
              // fontFamily: `"Helvetica Neue", "BlinkMacSystemFont", sans-serif, Arial, "Segoe UI"`,
              // fontFamily: ` Arial`,
            }}
          >
            tat
          </Box>
        </>
      )}
    </Box>
  );
}
